import {AbstractEvent} from "@/modules/base/events";

export class BeforeLineupChangedEndEvent extends AbstractEvent {
}
